import { createRouter, createWebHistory } from 'vue-router'
import Jobs from '../views/User/Jobs.vue'
import Archive from '../views/User/Archive.vue'
import Jobdetails from '../views/User/Jobdetails.vue'
import Chats from '../views/User/Chats.vue'
import Tasks from '../views/User/Tasks.vue'
import Chat from '../views/User/Chat.vue'
import Task from '../views/User/Task.vue'
import Dashboard from '../views/Dashboard.vue'
import ID from '../views/User/ID.vue'
import Info from '../views/User/Info.vue'
import Settings from '../views/User/Settings.vue'
import Group from '../views/User/Group.vue'
import Forbidden from '../views/Forbidden.vue'
import Impressum from '../views/User/Impressum.vue'
import Documents from '../views/User/Documents.vue'
import JobDocuments from '../views/User/JobDocuments.vue'
import AddJobDocument from '../views/User/AddJobDocument.vue'
import ViewJobDocument from '../views/User/ViewJobDocument.vue'
import Admincenter from '../views/Admin/Admincenter.vue'
import Login from '../views/Login.vue'
import Adminjobplanning from '../views/Admin/Adminjobplanning.vue'
import AdminjobplanningJSS from '../views/Admin/AdminjobplanningJSS.vue'
import Adminusers from '../views/Admin/Adminusers.vue'
import AdminEmployees from '../views/Admin/AdminEmployees.vue'
import AdminMeldeliste from '../views/Admin/AdminMeldeliste.vue'
import Admincheckin from '../views/Admin/Admincheckin.vue'
import AdminCreate from '../views/Admin/AdminCreate.vue'
import AdminLohn from '../views/Admin/AdminLohn.vue'
import AdminMessages from '../views/Admin/AdminMessages.vue'
import ExternalAdmin from '../views/Admin/ExternalAdmin.vue'
import Adminplan from '../views/Admin/Adminplan.vue'
import Adminjobs from '../views/Admin/Adminjobs.vue'
import AdminjobsJSS from '../views/Admin/AdminjobsJSS.vue'
import AdminJobSettings from '../views/Admin/AdminJobSettings.vue'
import AdminRoute from '../views/Admin/AdminRoute.vue'
import EWKSList from '../views/User/EWKSList.vue'
import Tour from '../views/User/Tour.vue'
import TemplateDashboard from '../views/Admin/TemplateDashboard.vue'
import AdminData from '../views/Admin/AdminData.vue'
import AdminDataEquipment from '../views/Admin/AdminDataEquipment.vue'
import AdminDataVertraege from '../views/Admin/AdminDataVertraege.vue'
import AdminDataContractDetails from '../views/Admin/AdminDataContractDetails.vue'
import AdminDataFeiertage from '../views/Admin/AdminDataFeiertage.vue'
import AdminTrainings from '../views/Admin/AdminTrainings.vue'
import AdminTarife from '../views/Admin/AdminTarife.vue'
import AdminKontakte from '../views/Admin/AdminKontakte.vue'
import Auswertungen from '../views/Admin/Auswertungen.vue'
import AdminInvoicing from '../views/Admin/AdminInvoicing.vue'
import AdminRechnungspruefung from '../views/Admin/AdminRechnungspruefung.vue'
import Zeitkonten from '../views/Admin/Zeitkonten.vue'
import AdminAccessCodes from '../views/Admin/AdminAccessCodes.vue'
import BadgePrint from '../views/Admin/BadgePrint.vue'
import AdminLayout from '../layouts/AdminLayout.vue'
import { hasAdminAccess, loadAdminSession } from '../admin/adminSession'

const adminAccess = {
  anyDispo: { anyOf: ['internalDispo', 'externalDispo'] },
  admin: { permission: 'admin' },
  employeeAdmin: { anyOf: ['admin', 'editEmployees'] },
  superadmin: { permission: 'superadmin' },
  internalDispo: { permission: 'internalDispo' },
  standby: { permission: 'standby' },
  documentsOrTours: { anyOf: ['documents', 'tours'] },
  locationManagement: { anyOf: ['documents', 'tours', 'internalDispo', 'admin'] },
  tours: { permission: 'tours' },
  external: { permission: 'external' }
}

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: Login
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { adminArea: true },
    children: [
      {
        path: '',
        name: 'Admincenter',
        component: Admincenter,
        meta: { title: 'Admin Center', nav: 'overview' }
      },
      {
        path: 'plan',
        name: 'Adminplan',
        component: Adminplan,
        meta: { title: 'Schichtplanung', nav: 'shiftPlan', adminAccess: adminAccess.anyDispo }
      },
      {
        path: 'external',
        name: 'ExternalAdmin',
        component: ExternalAdmin,
        meta: { title: 'Externer Bereich', nav: 'external', adminAccess: adminAccess.external }
      },
      {
        path: 'messages',
        name: 'AdminMessages',
        component: AdminMessages,
        meta: { title: 'Nachrichten', nav: 'messages', adminAccess: adminAccess.internalDispo }
      },
      {
        path: 'jobsettings',
        name: 'AdminJobSettings',
        component: AdminJobSettings,
        meta: { title: 'Schichtdokumente & Rundgänge', nav: 'jobSettings', adminAccess: adminAccess.locationManagement }
      },
      {
        path: 'routes',
        name: 'AdminRoutes',
        redirect: (to) => ({ name: 'AdminJobSettings', query: { ...to.query, section: 'tours' } }),
        meta: { title: 'Rundgänge', nav: 'jobSettings', adminAccess: adminAccess.tours }
      },
      {
        path: 'routes/create',
        name: 'CreateRoute',
        component: AdminRoute,
        meta: { title: 'Rundgang erstellen', nav: 'jobSettings', adminAccess: adminAccess.tours }
      },
      {
        path: 'routes/:id',
        name: 'ModifyRoute',
        component: AdminRoute,
        meta: { title: 'Rundgang bearbeiten', nav: 'jobSettings', adminAccess: adminAccess.tours }
      },
      {
        path: 'create',
        name: 'AdminCreate',
        component: AdminCreate,
        meta: { title: 'Auftrag anlegen', nav: 'create', adminAccess: adminAccess.admin }
      },
      {
        path: 'loehne',
        name: 'AdminLohn',
        component: AdminLohn,
        meta: { title: 'Löhne', nav: 'payroll', adminAccess: adminAccess.admin }
      },
      {
        path: 'checkin',
        name: 'Admincheckin',
        component: Admincheckin,
        meta: { title: 'Check-Ins', nav: 'checkins', adminAccess: adminAccess.standby }
      },
      {
        path: 'employees',
        name: 'AdminEmployees',
        component: AdminEmployees,
        meta: { title: 'Mitarbeiterverwaltung', nav: 'employees', adminAccess: adminAccess.employeeAdmin }
      },
      {
        path: 'meldeliste',
        name: 'AdminMeldeliste',
        component: AdminMeldeliste,
        meta: { title: 'Meldeliste', nav: 'meldeliste', adminAccess: { anyOf: ['admin', { allOf: ['externalDispo', 'editEmployees'] }] } }
      },
      {
        path: 'data',
        name: 'AdminData',
        component: AdminData,
        meta: { title: 'Datenverwaltung', nav: 'masterData', adminAccess: adminAccess.admin }
      },
      {
        path: 'data/equipment',
        name: 'AdminDataEquipment',
        component: AdminDataEquipment,
        meta: { title: 'Equipment', nav: 'equipment', adminAccess: adminAccess.admin }
      },
      {
        path: 'data/vertraege',
        name: 'AdminDataVertraege',
        component: AdminDataVertraege,
        meta: { title: 'Verträge', nav: 'contracts', adminAccess: adminAccess.admin }
      },
      {
        path: 'data/vertraege/:id',
        name: 'AdminDataContractDetails',
        component: AdminDataContractDetails,
        meta: { title: 'Vertragsdetails', nav: 'contracts', adminAccess: adminAccess.admin }
      },
      {
        path: 'data/holidays',
        name: 'AdminDataHolidays',
        component: AdminDataFeiertage,
        meta: { title: 'Feiertage', nav: 'holidays', adminAccess: adminAccess.admin }
      },
      {
        path: 'adminusers',
        name: 'Adminusers',
        component: Adminusers,
        meta: { title: 'Nutzerverwaltung', nav: 'adminUsers', adminAccess: adminAccess.superadmin }
      },
      {
        path: 'jobs',
        name: 'Adminjobs',
        component: Adminjobs,
        meta: { title: 'Aufträge', nav: 'jobs', adminAccess: adminAccess.anyDispo }
      },
      {
        path: 'jobs-jss',
        name: 'AdminjobsJSS',
        component: AdminjobsJSS,
        meta: { title: 'Aufträge – Tabelle', nav: 'jobsTable', adminAccess: adminAccess.anyDispo }
      },
      {
        path: 'planning',
        name: 'Adminjobplanning',
        component: Adminjobplanning,
        meta: { title: 'Auftragsplanung', nav: 'planning', adminAccess: adminAccess.admin }
      },
      {
        path: 'planning-jss',
        name: 'AdminjobplanningJSS',
        component: AdminjobplanningJSS,
        meta: { title: 'Auftragsplanung – Tabelle', nav: 'planningTable', adminAccess: adminAccess.admin }
      },
      {
        path: 'templates',
        name: 'TemplateDashboard',
        component: TemplateDashboard,
        meta: { title: 'Vorlagen', nav: 'templates', adminAccess: adminAccess.admin }
      },
      {
        path: 'trainings',
        name: 'AdminTrainings',
        component: AdminTrainings,
        meta: { title: 'Trainings', nav: 'trainings', adminAccess: adminAccess.admin }
      },
      {
        path: 'tarife',
        name: 'AdminTarife',
        component: AdminTarife,
        meta: { title: 'Tarife', nav: 'rates', adminAccess: adminAccess.admin }
      },
      {
        path: 'kontakte',
        name: 'AdminKontakte',
        component: AdminKontakte,
        meta: { title: 'Kontakte', nav: 'contacts', adminAccess: adminAccess.admin }
      },
      {
        path: 'auswertungen',
        name: 'Auswertungen',
        component: Auswertungen,
        meta: { title: 'Auswertungen', nav: 'reports', adminAccess: adminAccess.admin }
      },
      {
        path: 'invoicing',
        name: 'AdminInvoicing',
        component: AdminInvoicing,
        meta: { title: 'Abrechnung', nav: 'invoicing', adminAccess: adminAccess.admin }
      },
      {
        path: 'rechnungspruefung',
        name: 'AdminRechnungspruefung',
        component: AdminRechnungspruefung,
        meta: { title: 'Rechnungsprüfung', nav: 'invoiceReview', adminAccess: adminAccess.admin }
      },
      {
        path: 'zeitkonten',
        name: 'Zeitkonten',
        component: Zeitkonten,
        meta: { title: 'Zeitkonten', nav: 'timeAccounts', adminAccess: adminAccess.admin }
      },
      {
        path: 'accesscodes',
        name: 'AdminAccessCodes',
        component: AdminAccessCodes,
        meta: { title: 'Zugangscodes', nav: 'accessCodes', adminAccess: adminAccess.admin }
      },
      {
        path: 'tasks',
        name: 'AdminTasks',
        component: Tasks,
        props: { adminMode: true },
        meta: { title: 'Aufgaben', nav: 'tasks', adminAccess: adminAccess.internalDispo }
      },
      {
        path: 'tasks/:id',
        name: 'AdminTask',
        component: Task,
        props: { adminMode: true },
        meta: { title: 'Aufgabendetails', nav: 'tasks', adminAccess: adminAccess.internalDispo }
      }
    ]
  },
  {
    path: '/admin/badge/:userId',
    name: 'BadgePrint',
    component: BadgePrint,
    meta: { adminArea: true, adminAccess: adminAccess.employeeAdmin }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/job/:jobid/tours',
    name: 'EWKSList',
    component: EWKSList
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents
  },
  {
    path: '/jobdocuments',
    name: 'JobDocuments',
    component: JobDocuments
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum
  },
  {
    path: '/jobs',
    name: 'Aufträge',
    component: Jobs
  },
  {
    path: '/id',
    name: 'Dienstausweis',
    component: ID
  },
  {
    path: '/info',
    name: 'Persönliche Informationen',
    component: Info
  },
  {
    path: '/settings',
    name: 'Einstellungen',
    component: Settings
  },
  {
    path: '/archive',
    name: 'Archiv',
    component: Archive
  },
  {
    path: '/group/:groupid',
    name: 'Gruppe',
    component: Group
  },
  {
    path: '/jobs/:jobid/routes/:routeid/tours/:index',
    name: 'Tour',
    component: Tour
  },
  {
    path: '/chat',
    name: 'Chats',
    component: Chats
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks
  },
  {
    path: '/job/:jobid',
    name: 'Jobdetails',
    component: Jobdetails
  },
  {
    path: '/tasks/:id',
    name: 'Task',
    component: Task
  },
  {
    path: '/jobs/:jobid/documents',
    name: 'SpecificJobDocuments',
    component: JobDocuments
  },
  {
    path: '/jobs/:jobid/documents/add',
    name: 'AddJobDocument',
    component: AddJobDocument
  },
  {
    path: '/jobs/:jobid/documents/:doc',
    name: 'ViewJobDocument',
    component: ViewJobDocument
  },
  {
    path: '/jobs/:jobid/documents/:doc/edit',
    name: 'EditJobDocument',
    component: AddJobDocument
  },
  {
    path: '/chat/:chatid',
    name: 'chat',
    component: Chat
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Forbidden
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (!to.matched.some((record) => record.meta.adminArea)) {
    return true
  }

  const session = await loadAdminSession()
  if (session.status !== 200) {
    return { name: 'Forbidden' }
  }

  if (!hasAdminAccess(to.meta.adminAccess, session.stats?.permissions || {})) {
    return { name: 'Forbidden' }
  }

  return true
})

export default router
